(() => {
  const init = () => {
    // Product page: reliable "Comprar ahora" flow.
    document.querySelectorAll('[data-product-form]').forEach(form => {
      const buyNow = form.querySelector('[data-buy-now]');
      const select = form.querySelector('[data-variant-select]');
      const price = form.closest('.product-info')?.querySelector('.product-price');

      if (select && price) {
        select.addEventListener('change', () => {
          const option = select.options[select.selectedIndex];
          if (option?.dataset.price) price.textContent = option.dataset.price;
        });
      }

      if (!buyNow) return;
      buyNow.addEventListener('click', async () => {
        if (buyNow.disabled) return;
        const original = buyNow.textContent;
        buyNow.disabled = true;
        buyNow.textContent = 'Preparando compra…';
        try {
          const data = new FormData(form);
          data.delete('checkout');
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: data
          });
          if (!response.ok) throw new Error('No se pudo agregar el producto');
          window.location.assign(root + 'checkout');
        } catch (error) {
          buyNow.disabled = false;
          buyNow.textContent = original;
          if (typeof form.requestSubmit === 'function') form.requestSubmit(form.querySelector('[name="add"]'));
          else form.submit();
        }
      });
    });

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const root = document.querySelector('[data-hause]');

    // Existing home-page reveals.
    if (root) {
      const reveals = root.querySelectorAll('[data-reveal]');
      if ('IntersectionObserver' in window && !reduce) {
        const io = new IntersectionObserver(entries => entries.forEach(e => {
          if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
        }), {threshold:.08, rootMargin:'0px 0px -4% 0px'});
        reveals.forEach((el,i)=>{el.style.transitionDelay=`${Math.min((i%4)*70,210)}ms`;io.observe(el)});
      } else reveals.forEach(el=>el.classList.add('visible'));
    }

    const desktop = window.innerWidth >= 901;
    if (desktop) {
      document.body.classList.add('desktop-motion-ready');

      // Strong, visible scroll animations across the whole desktop theme.
      const desktopTargets = document.querySelectorAll(
        '.section-head, .product-card, .split-card, .workflow-head, .workflow-card, .delivery-panel, .support-head, .support-card, .statement, .collection-hero, .product-gallery, .product-info, .cart-line, .simple-page, .error-page'
      );
      desktopTargets.forEach((el, i) => {
        el.classList.add('desktop-reveal');
        el.style.transitionDelay = `${Math.min((i % 4) * 70, 210)}ms`;
      });
      if ('IntersectionObserver' in window) {
        const dio = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('desktop-visible');
            dio.unobserve(entry.target);
          }
        }), { threshold: .08, rootMargin: '0px 0px -5% 0px' });
        desktopTargets.forEach(el => dio.observe(el));
      } else desktopTargets.forEach(el => el.classList.add('desktop-visible'));
    }

    if (!root) return;

    root.querySelectorAll('.tilt').forEach(card=>{
      card.addEventListener('pointermove',e=>{
        if(window.innerWidth<901)return;
        const r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;
        card.style.transform=`perspective(1000px) rotateX(${-y*4}deg) rotateY(${x*5}deg) translateY(-5px)`;
      });
      card.addEventListener('pointerleave',()=>card.style.transform='');
    });

    root.querySelectorAll('.magnetic').forEach(btn=>{
      btn.addEventListener('pointermove',e=>{
        if(window.innerWidth<901)return;
        const r=btn.getBoundingClientRect();
        btn.style.transform=`translate(${(e.clientX-r.left-r.width/2)*.13}px,${(e.clientY-r.top-r.height/2)*.13}px) scale(1.02)`;
      });
      btn.addEventListener('pointerleave',()=>btn.style.transform='');
    });

    const parallax=root.querySelectorAll('.parallax');
    let ticking=false;
    const update=()=>{
      const sy=window.scrollY;
      parallax.forEach(el=>{
        const s=parseFloat(el.dataset.speed||'.035');
        el.style.transform=`translate3d(0,${sy*s}px,0) scale(1.06)`;
      });
      ticking=false;
    };
    window.addEventListener('scroll',()=>{if(!ticking){requestAnimationFrame(update);ticking=true}},{passive:true});
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
